import { Input } from '@fountain/fountain-ui-components';
import { Grid } from '@material-ui/core';
import React from 'react';
import { useIntl } from 'react-intl';

import { Error } from 'components/Error';
import { useErrorIds } from 'components/Error/useErrorIds';
import { useFieldEnhancementOptionsContextState } from 'components/FormBuilder/FieldEnhancementOptions/context';

import { useTextDataField } from './hooks';
import { TextFieldQuestionFormMessages } from './messages';
const {
  questionFormQuestionValidationLabel,
  questionFormQuestionValidationMessageLabel,
} = TextFieldQuestionFormMessages;

export const TextFieldForm = () => {
  const intl = useIntl();
  const errorId = useErrorIds();
  const { values, errors, handleChange } = useTextDataField();
  const { applyRegexValidation } = useFieldEnhancementOptionsContextState();
  return (
    <>
      {applyRegexValidation && (
        <>
          <Grid item xs={12}>
            <Input
              label={intl.formatMessage(questionFormQuestionValidationLabel)}
              value={values.format}
              required
              disabled={!applyRegexValidation}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                handleChange({ format: event.target.value })
              }
              error={Boolean(errors.format)}
              aria-describedby={errors.format ? errorId('format') : undefined}
            />
            <Error id={errorId('format')} error={errors.format} align="right" />
          </Grid>
          <Grid item xs={12}>
            <Input
              label={intl.formatMessage(
                questionFormQuestionValidationMessageLabel,
              )}
              value={values.format_validation_message}
              disabled={!applyRegexValidation}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                handleChange({ format_validation_message: event.target.value })
              }
              error={Boolean(errors.format_validation_message)}
              aria-describedby={
                errors.format_validation_message
                  ? errorId('format_validation_message')
                  : undefined
              }
            />
            <Error
              id={errorId('format_validation_message')}
              error={errors.format_validation_message}
              align="right"
            />
          </Grid>
        </>
      )}
    </>
  );
};
